__turbopack_context__.v({
  "card": "homepagePromoCard-module-scss-module__TJL6Uq__card",
  "cardContent": "homepagePromoCard-module-scss-module__TJL6Uq__cardContent",
  "cardContentSingle": "homepagePromoCard-module-scss-module__TJL6Uq__cardContentSingle",
  "cardCtaWrapper": "homepagePromoCard-module-scss-module__TJL6Uq__cardCtaWrapper",
  "cardDescription": "homepagePromoCard-module-scss-module__TJL6Uq__cardDescription",
  "cardDescriptionSingle": "homepagePromoCard-module-scss-module__TJL6Uq__cardDescriptionSingle",
  "cardMaskBackgroundDesktop": "homepagePromoCard-module-scss-module__TJL6Uq__cardMaskBackgroundDesktop",
  "cardMaskBackgroundMobile": "homepagePromoCard-module-scss-module__TJL6Uq__cardMaskBackgroundMobile",
  "cardMobilePhone": "homepagePromoCard-module-scss-module__TJL6Uq__cardMobilePhone",
  "cardMobilePhoneSingle": "homepagePromoCard-module-scss-module__TJL6Uq__cardMobilePhoneSingle",
  "cardRightBackground": "homepagePromoCard-module-scss-module__TJL6Uq__cardRightBackground",
  "cardRightBackgroundSingle": "homepagePromoCard-module-scss-module__TJL6Uq__cardRightBackgroundSingle",
  "cardSingle": "homepagePromoCard-module-scss-module__TJL6Uq__cardSingle",
  "cardTitle": "homepagePromoCard-module-scss-module__TJL6Uq__cardTitle",
  "homepagePromoCard": "homepagePromoCard-module-scss-module__TJL6Uq__homepagePromoCard",
  "wrapper": "homepagePromoCard-module-scss-module__TJL6Uq__wrapper",
});
